// account for vertical tabs + edge rounded corners
export const isDesktop = window.matchMedia("(min-width: 1860px)").matches
